/**
 * Resolves a Strapi media file object to a full image URL.
 * Handles both local storage (relative path) and cloud storage (absolute URL).
 *
 * @param {Object|null} file - Strapi file object with a `url` property
 * @returns {string|null} Full image URL, or null if no file provided
 */
const apiUrl = process.env.VUE_APP_API_URL;

export const imgUrl = (file) => {
  if (!file) return null;
  return file.url.startsWith("http") ? file.url : `${apiUrl}${file.url}`;
};

/**
 * Resolves a Strapi file object (any type: PDF, doc, etc.) to a full URL.
 * Alias of imgUrl with a semantically correct name for non-image files.
 *
 * @param {Object|null} file - Strapi file object with a `url` property
 * @returns {string|null} Full file URL, or null if no file provided
 */
export const fileUrl = (file) => {
  if (!file) return null;
  const url = file.url ?? file;
  return String(url).startsWith("http") ? String(url) : `${apiUrl}${url}`;
};

